
import * as types from '../actions/actionTypes'
import { assign } from 'lodash'

const initialState = {
  overlaysList:[{
    id: 1,
    altTxt: '',
    category:'',
    width: 1,
    height: 1,
    swatch: '',
    overlayWhite: '',
    overlayBlack: '',
    disabled: true
  }],
  overlay: {}
}

function overlays(state = initialState, action) {
  switch (action.type) {
    case types.OVERLAYS_FETCH_SUCCESS:
      console.log("action.res overlays--- ", action.res)
        return assign({}, state, {
          overlaysList: action.res,
        })
    case types.OVERLAY_SET_SUCCESS:
      return assign({}, state, action.res)
    case types.OVERLAY_FETCH_SUCCESS:
      console.log('ACTION RES', action.res)
    case types.OVERLAY_EDIT_SUCCESS:
      return assign({}, state, {
        overlay: action.res,
      });
    case types.OVERLAY_DELETE_SUCCESS:
      return assign({}, state, {
        overlayDelete: action.res.ok,
      });
    case types.OVERLAY_CLEAR_ERRORS:
      return assign({}, state, {
        error: false,
      });
    case types.OVERLAYS_FETCH_ERROR:
    case types.OVERLAY_SET_ERROR:
    case types.OVERLAY_FETCH_ERROR:
    case types.OVERLAY_EDIT_ERROR:
    case types.OVERLAY_DELETE_ERROR:
        // console.log('OVERLAY ERROR, action.type', action.type)
        return assign({}, state, {
          error: action.res,
        })
    default:
    return state;
  }
}

export default overlays 


// WEBPACK FOOTER //
// ./src/reducers/overlays.js